import { createHashHistory } from 'history';

export const myHistory = createHashHistory();
